export default {
  NAME_DOSE_NOT_EXIST: "نام وارد نشده است.",
};
